// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";

import { token } from "@atlaskit/tokens";

type BannerTitleProps = {
    children: string;
};

const bodyCss = css`
    margin: 0;

    font-size: ${token("space.200")};
    line-height: ${token("space.300")};
    font-weight: normal;
`;

const BannerTitle = ({ children }: BannerTitleProps) => {
    return <h3 css={bodyCss}>{children}</h3>;
};
export default BannerTitle;
